import React, { useState } from "react";
import { AppListing } from "../../components/appListing";
import { useGetHistoryQuery } from "../../redux/service/demographic_services";
import moment from "moment";

import AmendmentRequestUpPop from "./amendmentRequestUpPop";

const History = ({ crossHandler }) => {
  const { data: requestHistory, isLoading } = useGetHistoryQuery();
  const [previewData, setPreviewData] = useState(null);
  const cols = [
    {
      title: "Date/Time",
      getData: (data) => {
        const dateTime = moment(data?.created).format("MM/DD/YYYY hh:mm A");
        return dateTime;
      },
    },
    { title: "Status", key: "status" },
    {
      title: "Accepted/Cancelled On",
      getData: (data) => {
        const dateTime =  data?.processed_at?moment(data?.processed_at).format("MM/DD/YYYY hh:mm A"):"-";
        return dateTime;
      },
    },
    { title: "By", key: "processed_by_name" },
    {
      title: "Action",
      getData: () => <div className="rounded-md bg-blue-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 w-20 text-center">Details</div>,
      onClick: (item) => setPreviewData(item),
    },
  ];
 
  return (
    <>
      <div className="flex justify-between items-center flex-wrap sm:flex-nowrap px-3 py-3 sm:px-4 bg-gray-100 rounded-t-lg">
        <h3 className="text-lg font-bold tracking-wide leading-6">
          Requests History
        </h3>
        <div onClick={crossHandler}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-6 h-6 text-blue-600 hover:text-gray-600 cursor-pointer"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>
        </div>
      </div>
      <div className="mt-3">
        <AppListing
          cols={cols}
          listData={requestHistory?.data || []}
          loading={isLoading}
        />
      </div>
      {/* dialogs */}
      <AmendmentRequestUpPop previewData={previewData} isLoading={isLoading} setPreviewData={setPreviewData} />
    </>
  );
};

export default History;
